import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Main from './Main';
import About from './about/About';
import Project from './project/Project';
import ComingSoon from './ComingSoon';
import Business from './business/Business';
import Inquiry from './contact/Inquiry';
import Dashboard from './admin/Dashboard';
import ProjectListPage from './admin/Project';
import ClientListPage from './admin/Clients';
import LoginPage from './admin/LoginPage';
import UserListPage from './admin/Users';

export default (props) => {
  return (
    <HashRouter>
      <Switch>
        {/* <Route exact path="/" component={ComingSoon} /> */}
        <Route exact path="/" component={Main} />
        <Route exact path="/about/vision" component={About} />
        <Route exact path="/about/organization" component={About} />
        <Route exact path="/business/scope" component={Business} />
        <Route exact path="/business/client" component={Business} />
        <Route exact path="/project" component={Project} />
        <Route exact path="/project/:id" component={Project} />
        <Route exact path="/contact/inquiry" component={Inquiry} />
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/admin" component={Dashboard} />
        <Route exact path="/admin/project" component={ProjectListPage} />
        <Route exact path="/admin/client" component={ClientListPage} />
        <Route exact path="/admin/users" component={UserListPage} />
      </Switch>
    </HashRouter>
  );
};
